@if (unlockDynamicForm) {
	<div>
		<ng-container *ngTryFor="let config of configurations">
			<lbca-dynamic-form-module
				[configuration]="config"
				[externalData]="externalData"
				[cardData]="cardInfo"
				[context]="context"
				(formValidFunctionCallback)="setCalbacksArray($event)"
				(errorApi)="erroApi($event)"
				[disabled]="disabled"
				[forceStateOpened]="isOpenForced"
				[initialized]="initialized"
				(setControlCloud)="setControlCloud($event)"
				[error]="error"
				[processId]="processNumber"
				[dataAttr]="attr"
				[davaValues]="getEntityDataValues(config.entityKey)"
				[type]="formType"
				[origin]="origin"
			></lbca-dynamic-form-module>
		</ng-container>
		@if (formType === 'form-primary') {
			<div class="h-360 w-100p"></div>
		}
	</div>
}

@if (!unlockDynamicForm) {
	<div class="mt-[50px] p-[30px] mb-[40px]">
		<lbca-body-feedback place="body" feedbackIcon="notfound" type="row">
			<ng-container rowMessagePrimary>Nenhuma solicitação de pagamento encontrada!</ng-container>
		</lbca-body-feedback>
	</div>
}
